<template>
    <div class="con">
        <!-- 商家首页页面 -->
        <div class="coninner">
            <div class="contop">
                <div class="userAvatar">
                    <img :src="$img(info.avatar)" v-if="info.avatar" alt="" />
                    <img :src="$Localimg('defaultAvatar.png')" v-else alt="" />
                </div>
                <div class="userName" v-text="info.nickname">
                </div>
            </div>
            <div class="cDetail flx jsb">
                <div class="cdLeft">
                    <div class="clItem" :class="cur == 0?'active':''" @click="changeTab(0)">
                        <div class="shu" v-if="cur == 0"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('mi1.png')" alt="" />
                            </div>
                            <div class="cName">
                                我的订单
                            </div>
                        </div>
                    </div>

                    <div class="clItem" :class="cur == 1?'active':''" @click="changeTab(1)">
                        <div class="shu" v-if="cur == 1"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('mi2.png')" alt="" />
                            </div>
                            <div class="cName">
                                图书订单
                            </div>
                        </div>
                    </div>
                    
                    <div class="clItem" :class="cur == 8?'active':''" @click="changeTab(8)">
                        <div class="shu" v-if="cur == 8"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('mi2.png')" alt="" />
                            </div>
                            <div class="cName">
                                职业认证订单
                            </div>
                        </div>
                    </div>

                    <div class="clItem" :class="cur == 2?'active':''" @click="changeTab(2)">
                        <div class="shu" v-if="cur == 2"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('mi3.png')" alt="" />
                            </div>
                            <div class="cName">
                                我的关注
                            </div>
                        </div>
                    </div>

                    <div class="clItem" :class="cur == 3?'active':''" @click="changeTab(3)">
                        <div class="shu" v-if="cur == 3"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('mi4.png')" alt="" />
                            </div>
                            <div class="cName">
                                我的收藏
                            </div>
                        </div>
                    </div>

                    <div class="clItem" :class="cur == 4?'active':''" @click="changeTab(4)">
                        <div class="shu" v-if="cur == 4"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('mi5.png')" alt="" />
                            </div>
                            <div class="cName">
                                我的消息
                            </div>
                        </div>
                    </div>

                    <div class="clItem" :class="cur == 5?'active':''" @click="changeTab(5)">
                        <div class="shu" v-if="cur == 5"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('mi6.png')" alt="" />
                            </div>
                            <div class="cName">
                                收货地址
                            </div>
                        </div>
                    </div>
                   <div class="clItem" :class="cur == 6?'active':''" @click="changeTab(6)">
                        <div class="shu" v-if="cur == 6"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('pcjl.png')" alt="" />
                            </div>
                            <div class="cName">
                                我的简历
                            </div>
                        </div>
                    </div>
                    <div class="clItem" :class="cur == 7?'active':''" @click="changeTab(7)">
                        <div class="shu" v-if="cur == 7"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index7.png')" alt="" />
                            </div>
                            <div class="cName">
                                账号设置
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cdRight">
                    <corder v-if="cur == 0"></corder>
                    <order v-if="cur == 1"></order>
                    <focus v-if="cur == 2"></focus>
                    <message v-if="cur == 4"></message>
                    <adress v-if="cur == 5"></adress>
                    <collection v-if="cur == 3"></collection>
                    <setting @refresh='refreshs' :type="st" v-if="cur  == 7"></setting>
                    <zorder :type="st" v-if="cur  == 8"></zorder>
                    <jl v-if="cur == 6"></jl>
                </div>
            </div>
        </div>
        <div v-if="show">
            <Login @cal="show = false"></Login>
        </div>
    </div>
</template>

<script>
    import {
        userInfo
    } from "@/api/index.js"
    
    
    import zorder from './zorder.vue'
    import order from './order.vue'
    import focus from './focus.vue'
    import corder from './corder.vue'
    import message from './message.vue'
    import adress from './address.vue'
    import collection from './collection.vue'
    import setting from './setting.vue'
    import Login from '@/components/login.vue'
    import jl from "./myjl.vue"
    export default {
        components: {
            order,
            focus,
            corder,
            message,
            adress,
            collection,
            setting,
            Login,
            zorder,
            jl
        },
        name: 'Shop',
        data() {
            return {
                cur: 0,
                info: {},
                show:false,
                st:""
            }
        },
        activated() {
            this.getUser()
            if(this.$route.query.type == "info"){
                this.cur = 7
                this.st = 3
            }
        },
        methods: {
            refreshs(){
                this.getUser()
            },
            changeTab(e) {
                let that = this
                that.cur = e
            },
            toConfirm() {
                this.$router.push('/verify')
            },
            getUser() {
                let that = this
                userInfo().then((res) => {
                    console.log("user", res)
                    if (res.code == 1) {
                        that.info = res.data
                    }else if(res.code == -2){
                        that.show = true
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .clItem:hover {
        background: rgba(0, 122, 255, 0.07) !important;
        cursor: pointer;
    }

    .active {
        background: rgba(0, 122, 255, 0.07) !important;
    }

    .shu {
        height: 52px;
        width: 4px;
        background: #007AFF;
        position: absolute;
        left: 0;
        top: 0;
        flex-shrink: 0;
    }

    .cIcon {
        width: 20px;
        height: 20px;
        margin-right: 6px;
    }

    .cName {
        font-size: 14px;
        color: #333333;
    }

    .cIcon img {
        width: 100%;
        height: 100%;
    }

    .cItemInner {
        display: flex;
        box-sizing: border-box;
        padding-left: 20px;
        align-items: center;
    }

    .clItem {
        display: flex;
        height: 52px;
        position: relative;
    }

    .cdRight {
        width: 986px;
        background: #fff;
        border-radius: 10px;
    }

    .cdLeft {
        width: 200px;
        background: #fff;
        padding: 32px 0;
        border-radius: 10px;
        flex-shrink: 0;
        margin-right: 14px;
        height: 448px;
    }

    .cDetail {
        width: 1200px;
        position: relative;
        top: -40px;
        margin: 0 auto;

    }


    .userAvatar {
        box-sizing: border-box;
        padding: 20px 0 12px;
        text-align: center;
    }

    .userAvatar img {
        width: 66px;
        height: 66px;
        border-radius: 50%;
    }

    .coninner {
        position: relative;
        background: #f8f8f8;
        /* height: 50vh; */
    }

    .contop {
        height: 180px;
        width: 100%;
        background: url('https://hrxsl.com/pcImages/indexBk.png') no-repeat;
        background-size: 100% auto;
    }

    .userName {
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
    }
</style>